import styled, { css } from 'styled-components';
import { fonts } from '../../variables/fonts.js';
import { colors } from '../../variables/colors.js';
import { deviceWidths } from '../../variables/widths.js';
import { transitions } from '../../variables/transitions.js';

var themeMap = {
  'light-gray': {
    background: colors.lightGray,
    text: colors.darkGrayL1
  },
  'few-seats': {
    background: colors.rouge,
    text: colors.white
  },
  'few-seats-inverted': {
    background: colors.white,
    text: colors.almostblack
  },
  'gronare-val': {
    background: colors.grass,
    text: colors.white
  },
  filter: {
    background: colors.darkGray,
    text: colors.white
  },
  silver: {
    background: colors.silver,
    text: colors.darkGray
  }
};
var Tags = styled.ul.withConfig({
  displayName: "style__Tags",
  componentId: "sc-b0rytx-0"
})(["cursor:default;font-family:", ";font-size:15px;text-transform:uppercase;vertical-align:middle;display:flex;flex-wrap:wrap;gap:6px;", " ", ""], fonts.bold, function (props) {
  return props.responsive && css(["@media (max-width:", "){font-size:11px;}"], deviceWidths.tabletMax);
}, function (props) {
  return props.small && css(["font-size:11px;"]);
});
var Tag = styled.li.withConfig({
  displayName: "style__Tag",
  componentId: "sc-b0rytx-1"
})(["align-items:center;background:", ";color:", ";line-height:22px;padding:3px 12px;transition:color ", ",background ", ";&:last-of-type{margin-right:0;}", " ", " ", " ", " ", ""], colors.warmBlack, colors.white, transitions["default"], transitions["default"], function (props) {
  return props.responsive && css(["@media (max-width:", "){margin-bottom:4px;&:last-of-type{margin-bottom:0;}}"], deviceWidths.tabletMax);
}, function (props) {
  return props.responsive && !props.small && css(["@media (max-width:", "){line-height:21px;padding:1px 8px 0;}"], deviceWidths.tabletMax);
}, function (props) {
  return props.small && css(["line-height:19px;padding:0 4px 0;"]);
}, function (props) {
  return props.theme && themeMap[props.theme] && css(["background-color:", ";color:", ";"], themeMap[props.theme].background, themeMap[props.theme].text);
}, function (props) {
  return props.theme === 'filter' && css(["cursor:pointer;font-family:", ";font-size:15px;text-transform:none;transition:background ", ";@media (min-width:", "){&:hover{background:", ";}}"], fonts.bold, transitions["default"], deviceWidths.desktop, colors.almostblack);
});
var TagRemove = styled.span.withConfig({
  displayName: "style__TagRemove",
  componentId: "sc-b0rytx-2"
})(["padding-left:4px;"]);

export { Tag, TagRemove, Tags };
//# sourceMappingURL=style.js.map
